<template>
  <v-col cols="1">
    <div v-if="!action.group">
      <v-btn
        :icon="action.icon"
        variant="text"
        :color="isActive ? 'primary' : 'grey'"
        :disabled="loading"
        size="small"
        @click="action.callback"
      />
    </div>
    <div v-else>
      <v-menu offset-y location="bottom center">
        <template #activator="{ props }">
          <v-btn
            :icon="activeIcon"
            :disabled="loading"
            variant="text"
            size="small"
            color="grey"
            v-bind="props"
          />
        </template>
        <v-list class="d-flex flex-row">
          <v-list-item v-for="item in items" :key="item.name">
            <v-btn
              variant="text"
              :icon="item.icon"
              color="grey"
              size="small"
              @click="setActive(item) || handleChildClick(item)"
            />
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-col>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type Action from '@/types/Action'

interface Props {
  action: Action
  isActive?: boolean
  loading?: boolean
  items?: Action[]
}

const {
  action,
  isActive = false,
  loading = false,
  items = [],
} = defineProps<Props>()

const activeItem = computed(() => items?.find(item => item.active))

const activeIcon = computed(() => activeItem.value ? activeItem.value.icon : action.icon)

const setActive = (item: Action): boolean => {
  if (items) {
    items.forEach(i => (i.active = i.name === item.name))
  }

  return true
}

function handleChildClick(item: Action) {
  if (item.callback) {
    item.callback()
  }
}
</script>
